export const work_culture = [
  // --- 職場狀態 ---
  { char: '🫩', name: 'Bags Under Eyes', nameZh: '熬夜加班', keywords: ['overtime', 'tired', 'deadline'], year: 2025, hot: true },
  { char: '💻', name: 'Laptop', nameZh: '遠端工作', keywords: ['remote', 'digital nomad', 'coder'], hot: true },
  { char: '☕', name: 'Coffee', nameZh: '精神支柱', keywords: ['caffeine', 'break', 'morning'], hot: true },
  { char: '📊', name: 'Chart', nameZh: '數據分析', keywords: ['data', 'report', 'growth'] },
  { char: '📅', name: 'Calendar', nameZh: '會議行程', keywords: ['meeting', 'schedule', 'todo'] },
  { char: '🧠', name: 'Brain', nameZh: '腦力激盪', keywords: ['brainstorm', 'think', 'idea'], hot: true },
  { char: '🔋', name: 'Battery', nameZh: '充電中', keywords: ['energy', 'rest', 'power'] },
  { char: '📉', name: 'Chart Down', nameZh: '業績壓力', keywords: ['stress', 'low', 'bad'] },
  { char: '📈', name: 'Chart Up', nameZh: '達標成長', keywords: ['kpi', 'success', 'goal'], hot: true },
  { char: '🤝', name: 'Deal', nameZh: '商務合作', keywords: ['partnership', 'business', 'agree'] },
  { char: '🧘', name: 'Yoga', nameZh: '身心平衡', keywords: ['zen', 'relax', 'health'] },
  { char: '🏢', name: 'Office', nameZh: '公司打卡', keywords: ['office', 'city', 'work'] },
  { char: '💼', name: 'Briefcase', nameZh: '提案準備', keywords: ['pitch', 'pro', 'job'] },
  { char: '⏳', name: 'Hourglass', nameZh: '趕稿中', keywords: ['wait', 'time', 'deadline'] },
  { char: '🔈', name: 'Mute', nameZh: '會議靜音', keywords: ['silent', 'zoom', 'meeting'] },
];